module.exports = __webpack_public_path__ + "img/122ne.dca35ec6.svg";